import { createAction, createErrorAction } from '../../../helpers';
import { ErrorResponse } from '../../../../@types';
import { FuelTransactionsTypes } from '../../../../@types/enums';
import { FuelTransaction } from './initialState';

export const fuelTransactionsRequest = () =>
  createAction(FuelTransactionsTypes.FUEL_TRANSACTIONS_REQUEST);

export const fuelTransactionsSuccess = (payload: FuelTransaction[]) =>
  createAction(FuelTransactionsTypes.FUEL_TRANSACTIONS_SUCCESS, payload);

export const fuelTransactionsFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(FuelTransactionsTypes.FUEL_TRANSACTIONS_FAILURE, error);

export const setDisplayFuelTransactions = (payload: FuelTransaction[]) =>
  createAction(FuelTransactionsTypes.SET_DISPLAY_FUEL_TRANSACTIONS, payload);

export const setTotalFuelTransactions = (payload: number) =>
  createAction(FuelTransactionsTypes.SET_TOTAL_FUEL_TRANSACTIONS, payload);

export const selectFuelTransaction = (payload: FuelTransaction | null) =>
  createAction(FuelTransactionsTypes.SELECT_FUEL_TRANSACTION, payload);

export const fuelTransactionRequest = () =>
  createAction(FuelTransactionsTypes.FUEL_TRANSACTION_REQUEST);

export const fuelTransactionSuccess = (payload: FuelTransaction) =>
  createAction(FuelTransactionsTypes.FUEL_TRANSACTION_SUCCESS, payload);

export const fuelTransactionFailure = <E extends ErrorResponse>(error: E) =>
  createErrorAction(FuelTransactionsTypes.FUEL_TRANSACTION_FAILURE, error);
